import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

export const StyledNoSearchResults = styled.div`
    width: 100%;
    ${p => p.theme.utils.flex({ dir: 'column' })};
    text-align: center;
    margin-top: 90px;
    margin-bottom: 20px;

    ${cssMediaQueryBreakpoints.medium} {
        margin-top: 40px;
        margin-bottom: 0px;
    }

    & > div:first-child {
        margin-bottom: 8px;
    }

    p {
        font-size: 18px;
        font-weight: 500;
        color: ${p => p.theme.textColor};

        ${cssMediaQueryBreakpoints.medium} {
            font-size: 14px;
        }
    }
`
